/**
 * Suppliers — admin reference-data hook for the product supplier picker.
 *
 * Mirrors useBrands: plain useEffect + useState (admin does not use
 * TanStack Query), fetched on mount from GET /v1/admin/suppliers. Returns an
 * empty list on failure (the picker degrades to "— WMart own stock —") and
 * logs once.
 */
import { useEffect, useState } from "react";
import type { SupplierWithCountDTO } from "@wmart/shared-types";
import { api } from "./api-client.js";

interface ListResponse {
  suppliers: SupplierWithCountDTO[];
}

export interface UseSuppliersResult {
  data: SupplierWithCountDTO[];
  isLoading: boolean;
  isError: boolean;
}

export function useSuppliers(): UseSuppliersResult {
  const [state, setState] = useState<UseSuppliersResult>({
    data: [],
    isLoading: true,
    isError: false,
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get<ListResponse>("/v1/admin/suppliers")
      .then((res) => {
        if (cancelled) return;
        setState({ data: res.suppliers, isLoading: false, isError: false });
      })
      .catch((err) => {
        if (cancelled) return;
        console.warn({ context: "useSuppliers", err }, "suppliers_fetch_failed");
        setState({ data: [], isLoading: false, isError: true });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
